import type CommonProps from '@/types/Common.type';
import { TagType } from '@/utils/enum';

import DefaultTag from '../tags/DefaultTag';

interface RelatedCompanyIndustriesProps {
  industries: CommonProps[];
}

export default function RelatedCompanyIndustries({
  industries,
}: RelatedCompanyIndustriesProps) {
  return (
    <div className="hide-scrollbar flex flex-row space-x-2 overflow-x-auto px-5">
      {industries.map((item) => (
        <DefaultTag
          key={item.id}
          title={item.name}
          tagType={TagType.Default}
          className="my-1 whitespace-nowrap px-3 text-sm font-normal capitalize"
        />
      ))}
    </div>
  );
}
